// 用于项目logo | 标题配置
export default {
  title: "Nano Banana Turbo",
  logo: "https://bucketoss-2.oss-cn-shenzhen.aliyuncs.com/Banana.svg",
  logoHidden: true,
};
